/**
 * Pure helpers for the admin→vendor impersonation hand-off token/URL
 * (GPXUSAP-1860). Framework-free so they're directly unit-testable with
 * vitest (karma/ng-test is broken in this repo).
 *
 * IMPORTANT: the vendor SPA parses the token POSITIONALLY up to
 * pathSplit[8], and pathSplit[5] (the 5th "$$$"-joined segment) is its
 * `username`, which it posts to the impersonate API. The token must
 * therefore always be exactly five "$$$"-joined segments and stay
 * byte-identical regardless of caller intent — never append a 6th segment.
 * The upload-on-behalf landing is carried as a separate `landing` query
 * parameter instead, appended only for that intent.
 */
export function buildImpersonationToken(params: {
    sessionId: string;
    vendorCode: string;
    userName: string;
    loginUsername: string;
    sellerCode: string;
}): string {
    return [
        params.sessionId,
        params.vendorCode,
        params.userName,
        params.loginUsername,
        params.sellerCode,
    ].join("$$$");
}

export function buildImpersonationUrl(
    vendorBase: string,
    token: string,
    intent?: string
): string {
    let url = `${vendorBase}#/manage-user?token=${token}`;
    if (intent === "UPLOAD_ON_BEHALF") {
        url += "&landing=purchase-orders";
    }
    return url;
}
